// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../shared/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../shared/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  font-family: "Roboto", sans-serif;
}

h1 {
  margin: 0;
  padding: 0;
  font-family: "Roboto", sans-serif;
  font-size: 36px;
  font-weight: 800;
  line-height: 48px;

  @media (min-width: 768px) {
    font-size: 48px;
    line-height: 65px;
  }
}

h2 {
  margin: 0;
  padding: 0;
  font-family: "Roboto", sans-serif;
  font-size: 24px;
  font-weight: 600;
  line-height: 29px;
  letter-spacing: 0em;
}

.ant-table-cell-row-hover, .ant-table-wrapper .ant-table-tbody .ant-table-row.ant-table-row-hover>.ant-table-cell, .ant-table-wrapper .ant-table-tbody .ant-table-row.ant-table-row-selected>.ant-table-cell {
  background-color: #daecff !important;
}

.ant-picker-panels {
  flex-direction: column !important;

  @media (min-width: 768px) {
	  flex-direction: row !important;
  }
}

.ant-picker-outlined,
.ant-input-outlined {
  border-radius: 11px;
  font-size: 14px;
  padding: 12px 11px;
}

.ant-input-sm {
  padding: 6px 11px;
}

.ant-picker-input {
  & > input {
	  font-size: 14px !important;
  }
}

.ant-select-selector,
.ant-select-lg {
  min-height: 32px !important;
  font-size: 14px !important;
}

th {
  border-bottom: 1px solid #d2d1d4 !important;
  font-weight: 400;
}

.ant-select-selection-placeholder {
  text-align: left;
}

.ant-picker-outlined,
.ant-input-outlined {
  padding: 5.5px 11px;
  width: 100%;
}

.ant-select-multiple .ant-select-selector,
.ant-picker-outlined,
.ant-input-outlined {
  border-radius: 2px;
}

.ant-select-selector {
  text-align: left;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,iCAAiC;AACnC;;AAEA;EACE,SAAS;EACT,UAAU;EACV,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;;EAEjB;IACE,eAAe;IACf,iBAAiB;EACnB;AACF;;AAEA;EACE,SAAS;EACT,UAAU;EACV,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,iCAAiC;;EAEjC;GACC,8BAA8B;EAC/B;AACF;;AAEA;;EAEE,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE;GACC,0BAA0B;EAC3B;AACF;;AAEA;;EAEE,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,2CAA2C;EAC3C,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,mBAAmB;EACnB,WAAW;AACb;;AAEA;;;EAGE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":["* {\n  font-family: \"Roboto\", sans-serif;\n}\n\nh1 {\n  margin: 0;\n  padding: 0;\n  font-family: \"Roboto\", sans-serif;\n  font-size: 36px;\n  font-weight: 800;\n  line-height: 48px;\n\n  @media (min-width: 768px) {\n    font-size: 48px;\n    line-height: 65px;\n  }\n}\n\nh2 {\n  margin: 0;\n  padding: 0;\n  font-family: \"Roboto\", sans-serif;\n  font-size: 24px;\n  font-weight: 600;\n  line-height: 29px;\n  letter-spacing: 0em;\n}\n\n.ant-table-cell-row-hover, .ant-table-wrapper .ant-table-tbody .ant-table-row.ant-table-row-hover>.ant-table-cell, .ant-table-wrapper .ant-table-tbody .ant-table-row.ant-table-row-selected>.ant-table-cell {\n  background-color: #daecff !important;\n}\n\n.ant-picker-panels {\n  flex-direction: column !important;\n\n  @media (min-width: 768px) {\n\t  flex-direction: row !important;\n  }\n}\n\n.ant-picker-outlined,\n.ant-input-outlined {\n  border-radius: 11px;\n  font-size: 14px;\n  padding: 12px 11px;\n}\n\n.ant-input-sm {\n  padding: 6px 11px;\n}\n\n.ant-picker-input {\n  & > input {\n\t  font-size: 14px !important;\n  }\n}\n\n.ant-select-selector,\n.ant-select-lg {\n  min-height: 32px !important;\n  font-size: 14px !important;\n}\n\nth {\n  border-bottom: 1px solid #d2d1d4 !important;\n  font-weight: 400;\n}\n\n.ant-select-selection-placeholder {\n  text-align: left;\n}\n\n.ant-picker-outlined,\n.ant-input-outlined {\n  padding: 5.5px 11px;\n  width: 100%;\n}\n\n.ant-select-multiple .ant-select-selector,\n.ant-picker-outlined,\n.ant-input-outlined {\n  border-radius: 2px;\n}\n\n.ant-select-selector {\n  text-align: left;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
